export default function Login() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Document Review System
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Authentication is handled by Cloudflare Access
          </p>
        </div>
        <div className="rounded-md bg-blue-50 p-4">
          <div className="flex">
            <div className="ml-3">
              <h3 className="text-sm font-medium text-blue-800">
                Protected by Cloudflare Access
              </h3>
              <div className="mt-2 text-sm text-blue-700">
                <p>
                  This application requires authentication through Cloudflare Access.
                  If you're seeing this page, you may need to:
                </p>
                <ul className="list-disc pl-5 mt-2">
                  <li>Check with your administrator for access</li>
                  <li>Clear your browser cache and try again</li>
                  <li>Ensure you're using your @fanworld.gg email</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}